module.exports = __webpack_public_path__ + "static/media/Car_calligraphy_8_t.b72203a3.jpg";